import { useSystemStatusStore } from '@/entities/system';
import {
  SystemTimeoutScreen,
  SystemMaintenanceScreen,
} from '@/entities/system/ui';
import { Outlet } from 'react-router-dom';

const CommonRoute = () => {
  const { status } = useSystemStatusStore();

  if (status === 'timeout') {
    return <SystemTimeoutScreen />;
  }

  if (status === 'maintenance') {
    return <SystemMaintenanceScreen />;
  }

  return <Outlet />;
};

export default CommonRoute;
